/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import LangContext from "../../contextProvider/LangContext";
import SumDocsExcel from "./SumDocsExcel";

class SalesExcel extends Component {

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidUpdate() {
        document.title = "Cash On Tab - " + this.getText(21305);
    }

    render() {
      
        return (<SumDocsExcel
            {...this.props}
            isSales
            title={this.getText(21305)}
            docTypeList={'1,2,8,9,22,202,208,222'}
        />)
    }

}

export default SalesExcel;